export const Authorization = 'Authorization'
export const LastHref = 'LastHref'
export const RememberPsw = 'RememberPsw'
export const Passphrase = "my-scaffolding-123xa"
export const Info = "Info"